import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Spacer } from '@zillow/constellation';

import { UserSelectors } from 'app/shared/selectors';
import userUtils from 'app/shared/utils/userUtils';

import AddPropertyConstants from 'app/shared/constants/AddPropertyConstants';

import DeleteButton from 'app/shared/components/Modal/AddPropertyModal/components/DeleteButton';
import ArchiveButton from 'app/shared/components/Modal/AddPropertyModal/components/ArchiveButton';
import AddButton from 'app/shared/components/Modal/AddPropertyModal/components/AddButton';
import EditButton from 'app/shared/components/Modal/AddPropertyModal/components/EditButton';

const propTypes = {
    behavior: PropTypes.string.isRequired,
    listing: PropTypes.object.isRequired,
    isSubmitDisabled: PropTypes.bool.isRequired,
    verifyCanSubmitForm: PropTypes.func.isRequired,
    onStartSubmit: PropTypes.func.isRequired,
    onNewError: PropTypes.func.isRequired,
    onModalClose: PropTypes.func.isRequired,
    handleArchiveOrUnArchive: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(Object.values(AddPropertyConstants.ADD_MODE)),
};

const defaultProps = {
    mode: AddPropertyConstants.ADD_MODE.DEFAULT,
};

const { isPostingPathAdmin } = userUtils;

const ActionButtons = ({
    behavior,
    mode,
    listing,
    isSubmitDisabled,
    onStartSubmit,
    onNewError,
    verifyCanSubmitForm,
    onModalClose,
    handleArchiveOrUnArchive,
}) => {
    const { roles } = useSelector(state => UserSelectors.makeUser(state));

    // values are coming from current property model
    const {
        canBeArchived,
        isArchived,
        archived,
        isAddressEditable,
        isEditable,
        isFeed,
    } = listing;

    const isAdmin = isPostingPathAdmin(roles);
    const hasArchiveRestriction = !canBeArchived && !archived;
    const isArchiveButtonDisabled = isSubmitDisabled || hasArchiveRestriction;
    const isSaveDisabled = !isAddressEditable || !isEditable || archived;

    if (behavior === 'Add') {
        return (
            <AddButton
                isSubmitDisabled={isSubmitDisabled}
                mode={mode}
                verifyCanSubmitForm={verifyCanSubmitForm}
                onStartSubmit={onStartSubmit}
                onSubmitSuccess={onModalClose}
                onNewError={onNewError}
                listing={listing}
            />
        );
    }

    return (
        <Spacer paddingY="xs">
            <EditButton
                isSubmitDisabled={isSubmitDisabled || isSaveDisabled}
                verifyCanSubmitForm={verifyCanSubmitForm}
                onStartSubmit={onStartSubmit}
                onNewError={onNewError}
                onModalClose={onModalClose}
                listing={listing}
            />
            {isAdmin && !isFeed && (
                <DeleteButton
                    isSubmitDisabled={isSubmitDisabled}
                    onStartSubmit={onStartSubmit}
                />
            )}
            <ArchiveButton
                archived={archived}
                isArchived={isArchived}
                hasArchiveRestriction={hasArchiveRestriction}
                isArchiveButtonDisabled={isArchiveButtonDisabled}
                handleArchiveOrUnArchive={handleArchiveOrUnArchive}
            />
        </Spacer>
    );
};

ActionButtons.propTypes = propTypes;
ActionButtons.defaultProps = defaultProps;

export default ActionButtons;
